import { render, staticRenderFns } from "./password-setup.vue?vue&type=template&id=3f6e3e90&lang=html"
import script from "./password-setup.vue?vue&type=script&lang=js"
export * from "./password-setup.vue?vue&type=script&lang=js"
import style0 from "./password-setup.vue?vue&type=style&index=0&id=3f6e3e90&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports